import Vue from 'vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

// Retorna os cadastros individuais por microárea
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da equipe
 * @param {int} micro_area - Micro área do profissional
 */
export async function getCadastrosIndividuaisPorMicroArea(
  cod_ibge,
  nu_ine,
  micro_area
) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/risco-cardiovascular/' +
        cod_ibge +
        '/equipe/' +
        nu_ine +
        '/microarea/' +
        micro_area
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros individuais todos de uma equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getCadastrosIndividuaisTodosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/risco-cardiovascular/' + cod_ibge + '/equipe/' + nu_ine
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna o nome da cor de acordo com o valor
/**
 *
 * @param {int} valor - Valor numérico
 */
export function getCorTextoResultado(valor) {
  if (valor >= 50) {
    return 'blue'
  } else {
    return 'red'
  }
}

// Retorna o nome da cor para pintar a linha da tabela
/**
 *
 * @param {int} diferenca_dias - Valor numérico
 * @param {string} dt_atendimento -
 * @param {string} dt_pa
 */
export function printTableRow(item) {
  const risk_by_lab = item.risk_by_lab ? Number(item.risk_by_lab) : null
  const risk_by_imc = item.risk_by_imc ? Number(item.risk_by_imc) : null

  if (risk_by_lab === null && risk_by_imc === null) {
    return 'outro'
  }

  if (
    (risk_by_lab !== null && risk_by_lab < 5) ||
    (risk_by_imc !== null && risk_by_imc < 5)
  ) {
    return 'baixo'
  } else if (
    (risk_by_lab !== null && risk_by_lab >= 5 && risk_by_lab < 10) ||
    (risk_by_imc !== null && risk_by_imc >= 5 && risk_by_imc < 10)
  ) {
    return 'moderado'
  } else if (
    (risk_by_lab !== null && risk_by_lab >= 10 && risk_by_lab < 20) ||
    (risk_by_imc !== null && risk_by_imc >= 10 && risk_by_imc < 20)
  ) {
    return 'alto'
  } else if (
    (risk_by_lab !== null && risk_by_lab >= 20 && risk_by_lab < 30) ||
    (risk_by_imc !== null && risk_by_imc >= 20 && risk_by_imc < 30)
  ) {
    return 'muito-alto'
  } else if (
    (risk_by_lab !== null && risk_by_lab >= 30) ||
    (risk_by_imc !== null && risk_by_imc >= 30)
  ) {
    return 'critico'
  } else {
    return 'outro'
  }
}
export function exibirItensComNivel(cadastros, nivelSelecionado) {
  if (!nivelSelecionado) {
    return cadastros
  }

  let filtro = cadastros.filter((item) => {
    const risk_by_lab = item.risk_by_lab ? Number(item.risk_by_lab) : null
    const risk_by_imc = item.risk_by_imc ? Number(item.risk_by_imc) : null
    if (risk_by_lab === null && risk_by_imc === null) {
      return false
    }
    if (nivelSelecionado === 'baixo') {
      return (
        (risk_by_lab !== null && risk_by_lab < 5) ||
        (risk_by_imc !== null && risk_by_imc < 5)
      )
    } else if (nivelSelecionado === 'moderado') {
      return (
        (risk_by_lab !== null && risk_by_lab >= 5 && risk_by_lab < 10) ||
        (risk_by_imc !== null && risk_by_imc >= 5 && risk_by_imc < 10)
      )
    } else if (nivelSelecionado === 'alto') {
      return (
        (risk_by_lab !== null && risk_by_lab >= 10 && risk_by_lab < 20) ||
        (risk_by_imc !== null && risk_by_imc >= 10 && risk_by_imc < 20)
      )
    } else if (nivelSelecionado === 'muitoAlto') {
      return (
        (risk_by_lab !== null && risk_by_lab >= 20 && risk_by_lab < 30) ||
        (risk_by_imc !== null && risk_by_imc >= 20 && risk_by_imc < 30)
      )
    } else if (nivelSelecionado === 'critico') {
      return (
        (risk_by_lab !== null && risk_by_lab >= 30) ||
        (risk_by_imc !== null && risk_by_imc >= 30)
      )
    } else {
      return false
    }
  })

  return filtro
}

export function generatePdf(cadastros, selectEquipe, microArea) {
  let title_pdf = 'Risco Cardiovascular'
  let titlePdfSave = utils.methods.titlePdf(title_pdf, selectEquipe.no_equipe)
  let description_pdf = ''

  let headers_pdf = ''
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    let template = ''
    template = `${
      cadastros[i].nu_cpf != null ? 'CPF:' + cadastros[i].nu_cpf + '\n' : ''
    }${
      cadastros[i].nu_cns != null ? 'CNS:' + cadastros[i].nu_cns + '\n' : ''
    }NOME: ${cadastros[i].no_cidadao} \nNASCIMENTO: ${
      cadastros[i].dt_nascimento
    } \nMÃE: ${cadastros[i].no_mae} \nMA: ${
      cadastros[i].micro_area != null ? cadastros[i].micro_area : ''
    } \nATENDIMENTO: ${
      cadastros[i].atendimento != null ? cadastros[i].atendimento : ''
    } \nRISCO CARDIACO: ${
      cadastros[i].aval_ris_cardio != null ? cadastros[i].aval_ris_cardio : ''
    } \nHIPERTENSÃO: ${
      cadastros[i].hipertensao != null ? cadastros[i].hipertensao : ''
    } \nDIABETES: ${
      cadastros[i].diabetes != null ? cadastros[i].diabetes : ''
    } \nOBESIDADE: ${
      cadastros[i].obesidade != null ? cadastros[i].obesidade : ''
    } \nTABAGISMO: ${
      cadastros[i].tabagismo != null ? cadastros[i].tabagismo : ''
    } \nODONTO: ${
      cadastros[i].odonto != null ? cadastros[i].odonto : ''
    } \nVISITA: ${cadastros[i].visita != null ? cadastros[i].visita : ''}`

    obj.template = template

    data_pdf.push(obj)
  }
  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )
      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe ?? selectEquipe.no_esf_eap,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.ine_esf_eap,
          },
          {
            label: 'Microárea',
            value: microArea,
          },
        ],
        verticalPosition
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'left',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          const rowIndex = data.table.body.indexOf(data.row)

          if (rowIndex >= 0 && rowIndex < cadastros.length) {
            const item = cadastros[rowIndex]
            const rowColor = printTableRow(item)
            if (rowColor === 'baixo') {
              doc.setTextColor(44, 185, 71)
            } else if (rowColor === 'moderado') {
              doc.setTextColor(191, 195, 0)
            } else if (rowColor === 'alto') {
              doc.setTextColor(236, 127, 34)
            } else if (rowColor === 'muito-alto') {
              doc.setTextColor(188, 0, 32)
            } else if (rowColor === 'critico') {
              doc.setTextColor(77, 0, 5)
            } else {
              doc.setTextColor(0, 0, 0)
            }
          }
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}
